/*
    创建者：shuxiaokai
    创建时间：2019-12-11 21:17
    模块名称：xxxx
    备注：xxxx
*/
<template>
    <div class="header-wrapper">
        <div class="d-flex a-center toolbar-left">
            <span class="text-nowrap mr-2">数据集</span>
        </div>
        <div class="d-flex a-center toolbar-center">
            <div class="state-operation">
                <div class="hover-bg-gray-200 d-flex center flex-column">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconbaocun_mian" />
                    </svg>
                    <span class="mt-1">保存</span>
                </div>
                <div class="hover-bg-gray-200 d-flex center flex-column">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconchexiao" />
                    </svg>
                    <span class="mt-1">撤销</span>
                </div>
                <div class="hover-bg-gray-200 d-flex center flex-column">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconzhongzuo" />
                    </svg>
                    <span class="mt-1">重做</span>
                </div>
                <div class="d-flex">
                    <div class="hover-bg-gray-200 d-flex center flex-column px-1">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconsub" />
                        </svg>
                    </div>
                    <div class="d-flex center flex-column px-2">
                        <span>70%</span>
                        <span class="mt-1">缩放</span>
                    </div>
                    <div class="hover-bg-gray-200 d-flex center flex-column px-1">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconaddTodo-nav" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex a-center toolbar-right"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            datasetEnum: []
        };
    },
    created() {
    },
    methods: {
       
    }
};
</script>



<style lang="scss">
.header-wrapper {
    height: size(50);
    box-shadow: $box-shadow;
    background: $white;
    display: flex;
    padding: 0 20px;
    z-index: 1;
    position: relative;
    .icon {
       width: size(14); 
       height: size(14);
       fill: currentColor;
       overflow: hidden;
    }
    .toolbar-left {
        flex: 0 0 250px;
        margin-right: 20px;
    }
    .toolbar-center {
        flex: 1;
        font-size: size(12);
        .state-operation {
            height: 100%;
            display: flex;
            &>div {
                cursor: pointer;    
                padding: 0 10px;
                margin-right: 10px;
            }
        }
    }
    .toolbar-right {

    }
}
</style>
